/*
@PRODUCT_FEATURE: H 1.9.4.4
*/
import View from './View';

export { getDetailsTabStyles } from './View';
export default View;
